import { CommonModule, NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonMetaService, GtagService } from '@klubovna/shared-data';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgClass,
    TranslateModule,
  ],
  exports: [ TranslateModule, NgClass ],
  providers: [ CommonMetaService, GtagService ],
})
export class SharedModule {
}
